module.exports = __webpack_public_path__ + "img/P3.17149893.png";